export { LtlFreightPage } from './ltl-freight-page';
export { LtlFreightPage as default } from './ltl-freight-page';
